import { Outlet, useNavigate } from 'react-router-dom';
import useAuth from '../utils/useAuth';
import logo from '../assets/logos/logo-enstock-blanco.svg';
import '../styles/routes/LayoutAdmin.scss';

const LayoutAdmin = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/79834yhbdgyt562xa');
  };

  return (
    <div className="LA">
      <header className="LA__bar">
        <div className="LA__bar-left">
          <img src={logo} alt="En Stock Promocionales" className="LA__logo" />
          <span className="LA__badge">Panel Admin</span>
        </div>
        <div className="LA__bar-right">
          {user && (
            <span className="LA__user">
              <span className="LA__user-avatar">{user.charAt(0).toUpperCase()}</span>
              {user}
            </span>
          )}
          <button className="LA__logout" onClick={handleLogout}>
            Cerrar sesión
          </button>
        </div>
      </header>

      <main className="LA__content">
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutAdmin;
